import { mergeMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { ServerAction } from '../server.action';

type IDependencies = IClientApiDependencySegment;

export const removeServerStreamEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.removeServerStream.started),
  mergeMap((params) => {
    return dependencies.api.deleteServerStream(params).pipe(
      mergeMap(() => {
        return [
          ServerAction.removeServerStream.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          ServerAction.removeServerStream.failed({ params, error: undefined }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
